import { useQuery } from '@tanstack/react-query';

import { analyticsTypes } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

export const getInstagramReport: analyticsTypes.GetInstagramReport = (params) => {
  return axios.post(`/analytics/instagram`, params);
};

type QueryFnType = typeof getInstagramReport;

type UseGetInstagramReport = {
  dateFrom: number;
  dateTo: number;
  pageId: string;
  topic: string;
  geo: string;
  pageLink: string;
  config?: QueryConfig<QueryFnType>;
};

export const useGetInstagramReport = ({
  config = {},
  dateFrom,
  dateTo,
  pageId,
  geo,
  pageLink,
  topic,
}: UseGetInstagramReport) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['instagram-report', dateFrom, dateTo, topic, pageId, pageLink, geo],
    queryFn: () => getInstagramReport({ dateFrom, dateTo, topic, pageId, pageLink, geo }),
    enabled: !!dateFrom && !!dateTo,
    staleTime: 0,
  });
};
